/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { Route } from 'react-router-dom'

const HelpIndexPage = lazy(() => import('@/pages/help/HelpIndexPage').then((m) => ({ default: m.HelpIndexPage })))
const HelpGuidePage = lazy(() => import('@/pages/help/HelpGuidePage').then((m) => ({ default: m.HelpGuidePage })))

/** The Help centre (docs/ux/2026-09-24-help-center.md): the index and one guide. */
export function helpRoutes() {
  return (
    <>
      <Route path="/help" element={<HelpIndexPage />} />
      <Route path="/help/:slug" element={<HelpGuidePage />} />
    </>
  )
}
